import React from 'react'

import { PageWrap } from '../../layouts'

import { Profile, SettingsContainer } from './components'

const Settings = () => {
  return (
    <PageWrap title="Settings">
      <Profile />
      <SettingsContainer />
    </PageWrap>
  )
}

export default Settings
